import React from 'react';
import { AppBar, Toolbar, Box, Typography, Button, Container, IconButton, Avatar, Menu, MenuItem, ListItemIcon, Divider,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
 } from '@mui/material';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import {
  InboxOutlined,
  PermIdentityOutlined,
  PowerSettingsNewOutlined
} from '@mui/icons-material';
import LogoutDialog from '../components/LogoutDialog';

const UserLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openLogoutDialog, setOpenLogoutDialog] = React.useState(false);

  const user = JSON.parse(localStorage.getItem('user')) || { name: 'Χρήστης', email: '-' };



  const menuItems = [
    { text: 'Συσκευές', path: '/devices', default: true, icon: <InboxOutlined /> },
    { text: 'Λογαριασμός', path: '/account', default: false, icon: <PermIdentityOutlined /> },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>

      <AppBar position="sticky" elevation={0} sx={{ bgcolor: '#fff', color: '#000' }}>
        <Container maxWidth={false}>
          <Toolbar  sx={{ justifyContent: 'space-between', px: { xs: 0 }, minHeight: '0px !important', }}>

            <Box
              sx={{

                display: { xs: 'none', md: 'flex' },
                flex: '0',
                minWidth: '180px',
                alignItems: 'center',
                textDecoration: 'none',
                transition: 'opacity 0.2s',
                '&:hover': { opacity: 0.8 }
              }}
            >
              <Box
                component="img"
                src="/images/logo.png"
                alt="Beehive Logo"
                sx={{
                  width: '180px',
                  height: '60px',
                  display: 'block'
                }}
              />
            </Box>

            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', gap: 0 }}>
              {menuItems.map((item) => {

                const isActive = item.default && location.pathname == '/' ? true : location.pathname.startsWith(item.path);

                return (
                  <Button
                    key={item.text}
                    onClick={() => navigate(item.path)}
                    variant="text"
                    sx={{
                      flexDirection: 'column',
                      borderRadius: 0,
                      textTransform: 'uppercase',
                      p: 0,
                      py: 1,
                      width: '90px',
                      color: 'inherit',
                      transition: 'all 0.2s',
                      bgcolor: isActive ? 'primary.light':'transparent',
                      '&:hover': {
                        bgcolor: 'primary.main'
                      },
                      '& .MuiButton-startIcon': {
                        margin: 0,
                        mb: 0.5,
                        '& > svg': { fontSize: '32px !important', opacity: isActive ? 1 : 0.5 }
                      },
                      '&:hover .MuiButton-startIcon': {
                        '& > svg': { opacity: 1}
                      }
                    }}
                    startIcon={React.cloneElement(item.icon, { sx: {  } })}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: '0.6rem',
                        letterSpacing: '0.05em'
                      }}
                    >
                      {item.text}
                    </Typography>
                  </Button>
                );
              })}
            </Box>

            <Box sx={{
              flex: '0',
              minWidth: '180px',
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'flex-end'
              }}>
              <IconButton
                onClick={() => setOpenLogoutDialog(true)}
                sx={{
                  color: 'inhrerit',
                  border: 'none',
                  bgcolor: 'transparent',
                  transition: 'all 0.2s',
                  '&:hover': {
                    color: 'white',
                    bgcolor: 'error.main'
                  }
                }}
              >
                <PowerSettingsNewOutlined />
              </IconButton>

              <LogoutDialog
                open={openLogoutDialog}
                onClose={() => setOpenLogoutDialog(false)}
              />
            </Box>

          </Toolbar>
        </Container>
      </AppBar>

      <Box component="main" sx={{ flexGrow: 1}}>

          {children}
      </Box>
    </Box>
  );
};

export default UserLayout;
